export const REACT_APP_API_MERCURE_ENDPOINT  = 'https://designer.textilwerk.io/.well-known/mercure';
